import { getRoute } from '../../menu-constants'
import { useTranslation } from 'react-i18next'

export const DndLink = ({ link }) => {
  const { t } = useTranslation()
  const informations = getRoute(link.label)

  return (
    <>
      <div>
        <span
          className={`${
            informations.navigationMenuInformation.iconIsFilled
              ? 'material-icons notranslate'
              : 'material-icons-outlined notranslate'
          }`}
        >
          {informations.navigationMenuInformation.iconName}
        </span>
        <span>{t(informations.name)}</span>
      </div>
      <span className="material-icons-outlined notranslate">drag_indicator</span>
    </>
  )
}

export default DndLink
